import type { ProductImageTone } from "./productCatalogFixtures";

const PRODUCT_IMAGE_COLORS: Record<ProductImageTone, [string, string]> = {
	0: ["#E91E63", "#FFE3EE"],
	1: ["#FFD629", "#FFF4D6"],
	2: ["#2EC4B6", "#DDF6F2"],
	3: ["#F49AC1", "#FDEAF3"],
};

// Design placeholder product art.
export const productImageUri = (imageTone: ProductImageTone) => {
	const [accentColor, backgroundColor] = PRODUCT_IMAGE_COLORS[imageTone];
	const svgMarkup = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64"><rect width="64" height="64" fill="${backgroundColor}"/><path d="M20 14h24l3 8v28a4 4 0 0 1-4 4H21a4 4 0 0 1-4-4V22z" fill="${accentColor}" stroke="#16191F" stroke-width="2.5" stroke-linejoin="round"/><rect x="23" y="27" width="18" height="14" rx="4" fill="#fff" stroke="#16191F" stroke-width="2"/><path d="M27 32h10M27 36h7" stroke="#16191F" stroke-width="2" stroke-linecap="round"/></svg>`;
	return `data:image/svg+xml;utf8,${encodeURIComponent(svgMarkup)}`;
};
